import { gql } from '@apollo/client';
export const getPortfolioAnalysisData = gql`
    query getPortfolioAnalysisData(
        $dimension: SamyaString!
        $timePeriod: JSONString!
        $attributeType: SamyaString!
        $promotionMechanics: [String]
        $promoTypes: [String]
        $limit: Int!
        $offset: Int!
        $filters: JSONString!
    ) {
        getPortfolioAnalysisData(
            dimension: $dimension
            timePeriod: $timePeriod
            attributeType: $attributeType
            promotionMechanics: $promotionMechanics
            promoTypes: $promoTypes
            limit: $limit
            offset: $offset
            filters: $filters
        ) {
            data {
                attributeName
                attributeData {
                    mechanicsName
                    mechanicsData {
                        promoName
                        weeks
                        kpisData {
                            kpiName
                            kpiValue
                            kpiColor {
                                R
                                G
                                B
                            }
                        }
                    }
                }
            }
            meta {
                count
            }
        }
    }
`;

export const getPortfolioAnalysisBubbleChartData = gql`
    query getPortfolioAnalysisBubbleChartData(
        $timePeriod: JSONString!
        $groupBy1: SamyaString!
        $groupBy2: SamyaString!
        $dimension1: SamyaString!
        $dimension2: SamyaString!
        $filters: JSONString!
    ) {
        getPortfolioAnalysisBubbleChartData(
            timePeriod: $timePeriod
            groupBy1: $groupBy1
            groupBy2: $groupBy2
            dimension1: $dimension1
            dimension2: $dimension2
            filters: $filters
        ) {
            groupBy1
            groupBy2
            weeks
            kpisData {
                kpiName
                kpiValue
            }
        }
    }
`;

export const getMechanicsTacticsDropDownValues = gql`
    query getMechanicsTacticsListData($timePeriod: JSONString!, $filters: JSONString!) {
        getMechanicsTacticsListData(timePeriod: $timePeriod, filters: $filters) {
            mechanicsList
            tacticsList
        }
    }
`;
